import { useMemo } from 'react';
import { usePage } from '@inertiajs/react';

import { PageProps } from '@/types';
import {
    EMERGENCY_BANNER_SEVERITY_ERROR,
    EMERGENCY_BANNER_SEVERITY_INFO,
    EmergencyBannerSeverity,
} from '@/types/emergencyBanner.type';

function getBg(severity: EmergencyBannerSeverity) {
    if (severity === EMERGENCY_BANNER_SEVERITY_ERROR) {
        return 'bg-brand-red text-white';
    } else if (severity === EMERGENCY_BANNER_SEVERITY_INFO) {
        return 'bg-brand-teal text-white';
    }

    return 'bg-brand-yellow text-brand-ocean';
}

export function useEmergencyBannerData() {
    const page = usePage<PageProps<{}>>();

    const emergencyBanner = page.props?.emergencyBanner;

    const data = useMemo(() => {
        if (!emergencyBanner) {
            return null;
        }

        const bg = getBg(emergencyBanner.severity);

        const content = (
            <div className="[&_a]:text-brand-blue [&_a]:underline">
                <b className="mr-1">{emergencyBanner.title}</b>
                <span
                    dangerouslySetInnerHTML={{
                        __html: emergencyBanner.message,
                    }}
                />
            </div>
        );

        return { content, bg };
    }, [emergencyBanner]);

    return {
        data,
    };
}
